module.exports = __webpack_public_path__ + "static/media/arrows-green.4d313870.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/arrows-green.gif
// module id = 114
// module chunks = 0